import React, { useEffect } from 'react'
import { Dropdown, Avatar as AntdAvatar } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import {
  LogoutOutlined,
  UserOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import NavItem from './NavItem'
import Flex from 'components/shared-components/Flex'
import { signOut } from 'store/slices/identitySlice'
import { onSwitchTheme } from 'store/slices/themeSlice'
import { useThemeSwitcher } from 'react-css-theme-switcher'
import styled from '@emotion/styled'
import {
  FONT_WEIGHT,
  MEDIA_QUERIES,
  SPACER,
  FONT_SIZES,
  THEME_STORAGE,
} from 'constants/ThemeConstant'
import { Switch } from 'antd'
import { APP_PREFIX_PATH } from 'configs/AppConfig'
import { useNavigate } from 'react-router-dom'

const Icon = styled.div(() => ({
  fontSize: FONT_SIZES.LG,
}))

const UserWrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
}))

const UserInfo = styled('div')`
  padding-left: ${SPACER[2]};

  @media ${MEDIA_QUERIES.MOBILE} {
    display: none;
  }
`

const Avatar = styled(AntdAvatar)`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
`

const Name = styled.div(() => ({
  fontWeight: FONT_WEIGHT.SEMIBOLD,
}))

const Title = styled.span(() => ({
  opacity: 0.8,
}))

const MenuItemThemeSwitch = (props) => {
  const dispatch = useDispatch()
  const { switcher, themes, status } = useThemeSwitcher()
  const { currentTheme } = useSelector((state) => state.theme)

  const toggleTheme = () => {
    document.body.classList.add('remove-transition')

    const changedTheme = currentTheme !== 'dark' ? 'dark' : 'light'
    dispatch(onSwitchTheme(changedTheme))
    switcher({ theme: themes[changedTheme] })
    localStorage.setItem(THEME_STORAGE, changedTheme)
  }

  useEffect(() => {
    if (status === 'loaded') {
      document.body.classList.remove('remove-transition')
    }
  }, [status])

  return (
    <div onClick={() => toggleTheme()}>
      <Flex justifyContent='space-between' gap={SPACER[2]}>
        <span>{props.label}</span>

        <Switch checked={currentTheme === 'dark'} />
        {/* <Switch checked={currentTheme === 'dark'} onChange={toggleTheme} /> */}
      </Flex>
    </div>
  )
}

const MenuItemSettings = (props) => {
  const navigate = useNavigate()

  return (
    <div onClick={() => navigate(`${APP_PREFIX_PATH}/settings`)}>
      <Flex alignItems='center' gap={SPACER[2]}>
        <Icon>
          <SettingOutlined />
        </Icon>

        <span>{props.label}</span>
      </Flex>
    </div>
  )
}

const MenuItemSignOut = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    try {
      await dispatch(signOut()).unwrap()
      navigate(0)
    } catch {
      // do nothing
    }
  }

  return (
    <div onClick={handleSignOut}>
      <Flex alignItems='center' gap={SPACER[2]}>
        <Icon>
          <LogoutOutlined />
        </Icon>

        <span>{props.label}</span>
      </Flex>
    </div>
  )
}

const items = [
  {
    key: 'Dark Theme',
    label: <MenuItemThemeSwitch label='Tema escuro' />,
  },
  {
    key: 'Settings',
    label: <MenuItemSettings label='Configurações' />,
  },
  {
    key: 'Sign Out',
    label: <MenuItemSignOut label='Sair' />,
  },
]

export const UserNav = ({ mode }) => {
  const me = useSelector((state) => state.auth.me)

  return (
    <Dropdown placement='bottomRight' menu={{ items }} trigger={['click']}>
      <NavItem mode={mode}>
        <UserWrapper>
          <Avatar
            size={38}
            src='/img/avatars/thumb-6.jpg'
            icon={<UserOutlined />}
          />

          <UserInfo className='profile-text'>
            <Name>{me?.name}</Name>

            <Title>{me?.username}</Title>
          </UserInfo>
        </UserWrapper>
      </NavItem>
    </Dropdown>
  )
}

export default UserNav
